import script from "./LandingPageAirportTransferUAE.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingPageAirportTransferUAE.vue?vue&type=script&setup=true&lang=ts"

import "./LandingPageAirportTransferUAE.vue?vue&type=style&index=0&id=64632896&scoped=true&lang=css"
import "./LandingPageAirportTransferUAE.vue?vue&type=style&index=1&id=64632896&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64632896"]])

export default __exports__